( function ( $ ) {
	function plainText( html ) {
		return $( '<div>' ).html( html ).text();
	}

	function selectionCard( composite, component ) {
		const title = plainText( component.get_title() );
		const $card = $( '<h2 class="aconvert-composite-recap__label"></h2>' +
			'<div class="aconvert-composite-recap__item" data-bg="gray-extra-light">' +
			'<div class="row g-2">' +
			'<div class="col-auto"><div class="photo"><img class="aconvert-composite-recap__image" alt="" hidden></div></div>' +
			'<div class="aconvert-composite-recap__details col align-self-center">' +
			'<div class="aconvert-composite-recap__selection"></div></div>' +
			'<div class="col-auto align-self-center"><a class="btn btn-stroke btn-sm aconvert-composite-recap__change"></a></div></div></div>' );

		$card.filter( '.aconvert-composite-recap__label' ).text( component.get_title_index() + '. ' + title );
		$card.find( '.aconvert-composite-recap__change' )
			.text( 'Change ' + title )
			.attr( 'href', component.get_route() )
			.on( 'click', function ( event ) {
				event.preventDefault();
				composite.navigate_to_step( component );
			} );

		const $selection = $card.find( '.aconvert-composite-recap__selection' );
		$( '<h3 class="xs">' ).text( plainText( component.get_selected_product_title( false ) ) ).appendTo( $selection );
		// Use the native selection model, including chosen attributes such as die-cut Size.
		const $meta = $( '<ul class="aconvert-composite-recap__attributes">' );
		component.component_selection_model.get_meta_data().forEach( function ( item ) {
			$( '<li class="sm attribute-' + item.meta_key.toLowerCase().replace( /\s+/g, '-' ) + '">' ).text( plainText( item.meta_key ).replace( /:\s*$/, '' ) + ': ' + plainText( item.meta_value ) ).appendTo( $meta );
		} );
		if ( $meta.children().length ) {
			$meta.appendTo( $selection );
		}

		const image = component.get_selected_product_image_data( false );
		if ( image && image.image_src ) {
			$card.find( '.aconvert-composite-recap__image' ).attr( {
				src: image.image_src,
				srcset: image.image_srcset || '',
				sizes: image.image_sizes || '',
			} ).prop( 'hidden', false );
		}

		return $card;
	}

	function bindStepRecap( composite ) {
		if ( composite.settings.layout !== 'paged' ||
			composite.settings.layout_variation === 'componentized' ||
			composite.aconvertStepRecapBound ) {
			return;
		}

		composite.aconvertStepRecapBound = true;

		function updateRecaps() {
			const components = composite.get_components();
			components.forEach( function ( component, index ) {
				if ( index === 0 ) {
					return;
				}

				let $recap = component.$el.children( '.aconvert-composite-recap' );
				if ( ! $recap.length ) {
					$recap = $( '<section class="aconvert-composite-recap" aria-label="Previous selections" hidden>' );
					$recap.prependTo( component.$el );
				}

				$recap.empty();
				components.slice( 0, index ).forEach( function ( previous ) {
					if ( previous.is_visible() && Number( previous.get_selected_product( false ) ) > 0 &&
						previous.is_selected_product_valid() ) {
						$recap.append( selectionCard( composite, previous ) );
					}
				} );
				$recap.prop( 'hidden', ! $recap.children().length );
			} );
		}

		[ 'initialize_composite', 'component_selection_changed', 'component_selection_content_changed',
			'component_summary_content_updated', 'active_step_changed', 'step_visibility_changed' ].forEach( function ( action ) {
			composite.actions.add_action( action, updateRecaps, 150, composite );
		} );

		if ( composite.is_initialized ) {
			updateRecaps();
		}
	}

	$( document ).on( 'wc-composite-initializing wc-composite-initialized', function ( event, composite ) {
		bindStepRecap( composite );
	} );

	$( function () {
		$( '.composite_form' ).each( function () {
			const composite = $( this ).wc_get_composite_script ? $( this ).wc_get_composite_script() : false;
			if ( composite ) {
				bindStepRecap( composite );
			}
		} );
	} );
} )( jQuery );
